import type { JSX } from "solid-js";
import { COPYRIGHT } from "./credit.ts";

export function Credit(props: { class?: string }): JSX.Element {
  return <p class={props.class ?? "mk-credit"}>{COPYRIGHT}</p>;
}
